import bp from './brakePoints';
import debounce from 'debounce';
import Swiper from 'swiper';

// при изменени брейкпоинта показывает или прячет статьи в списке новостей
// так же включает слайдер на планшете

let test = document.querySelector('.js-news-feed-test'),
	items = document.querySelectorAll('.js-news-feed-item'),
	list = document.querySelector('.js-news-feed-list'),
	parent = document.querySelector('.js-news-feed-parent'),
	$slider = $(list),
	isSlider = false,
	$save;

// window.addEventListener('resize', onResize);

if(parent) {
	let news;
	
	function onResize() {
		let testHeight = test.offsetHeight,
			itemsHeight = 0,
			offsetTop = list.offsetTop;
		items.forEach(item => item.classList.remove('invisible'));
		
		if (['desktop', 'desktop-wide'].includes(bp.current)) {
			items.forEach(function(value) {
				let height = value.offsetHeight;
				
				parent.style.height = testHeight + 'px';
				
				if (itemsHeight + height + offsetTop + 80 > testHeight) {
					value.classList.add('invisible');
				} else {
					itemsHeight += height;
					value.classList.remove('invisible');
				}
			});
		} else {
			// items.forEach(item => item.classList.remove('invisible'));
			parent.style.height = null;
		}
		
		
		// slider on tablets
		if (['tablet'].includes(bp.current)) {
			if (!isSlider) {
				isSlider = true;
				$(list).addClass('swiper-container');
				$('.js-news-feed-list-inner').addClass('swiper-wrapper');
				$(items).addClass('swiper-slide');
				news = new Swiper($slider[0],{
					spaceBetween: 20,
					slidesPerView: 2,
					slidesPerGroup: 2,
					pagination: {
						el: '.js-news-feed-dots',
						clickable: true
					}
				});
			}
		} else {
			if (isSlider) {
				isSlider = false;
				news.destroy(true, true);
				$(list).removeClass('swiper-container');
				$('.js-news-feed-list-inner').removeClass('swiper-wrapper');
				$(items).removeClass('swiper-slide');
				onResize();
			}
		}
	}
	
	window.onresize = debounce(onResize, 200);
	onResize();
}

